/* =========================================================
   Maison · script global
   Configuración: snippets/maison-head.liquid → <script id="maison-config">.
   Todo el marcado se arma en Liquid; acá solo hay comportamiento:
   1. Estado del documento (scroll, foco con teclado, volver arriba)
   2. Entradas al hacer scroll
   3. Carrusel Maison
   4. Ficha de producto: despacho según la hora, WhatsApp con el talle elegido
   5. Componentes: <maison-ars-price>, <maison-size-guide>
   ========================================================= */
(function () {
  'use strict';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('maison-config').textContent) || {}; } catch (e) {}
  var T = CFG.t || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = root.classList.contains('shopify-design-mode');
  var animate = CFG.animations !== false && !reduceMotion && !inEditor && 'IntersectionObserver' in window;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Limpieza única: versiones anteriores guardaban el catálogo completo en el navegador
  try {
    Object.keys(localStorage).forEach(function (k) { if (k.indexOf('maison-catalog') === 0) localStorage.removeItem(k); });
    localStorage.removeItem('thc-catalog-reset');
  } catch (e) {}

  /* =========================================================
     1. ESTADO DEL DOCUMENTO
     ========================================================= */
  // Mouse/táctil oculta los recuadros de foco de los botones de cerrar; el teclado los muestra
  document.addEventListener('pointerdown', function () { root.classList.add('maison-pointer'); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') root.classList.remove('maison-pointer'); }, true);

  var topButton = null;
  var ticking = false;
  function onScroll() {
    var y = window.scrollY || 0;
    root.classList.toggle('maison-scrolled', y > 40);
    if (topButton) topButton.classList.toggle('is-visible', y > window.innerHeight * 1.5);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  function initBackToTop() {
    topButton = document.querySelector('.maison-top');
    if (!topButton) return;
    topButton.hidden = false;
    topButton.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* =========================================================
     2. ENTRADAS AL HACER SCROLL
     ========================================================= */
  var io = null;
  function watch(el) {
    if (!animate) { el.classList.add('is-revealed'); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // también lo que quedó por encima (scroll rápido o ancla)
          if (e.isIntersecting || e.boundingClientRect.top < 0) {
            e.target.classList.add('is-revealed');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    }
    io.observe(el);
  }

  function firstSection() { return document.querySelector('#MainContent > .shopify-section'); }
  function skipReveal(el, first) {
    return (first && el.closest('.shopify-section') === first) ||
      el.closest('header, footer, dialog, [role="dialog"], cart-drawer-component, .header-section, .product-details');
  }

  // Tarjetas y fotos: solo fundido
  var ITEMS = 'product-card, .collection-card, .maison-card, [data-maison-media]';
  // Textos y botones: suben con fundido, en orden dentro de cada bloque
  var GROUPS = [
    '.maison-editorial__caption', '.maison-split__caption', '.maison-story__intro', '.maison-story__card',
    '.maison-carousel__head', '.maison-categories', '.maison-editorial__more', '.maison-trust__list',
    '.section-resource-list__content > .group-block', '.mcl__head'
  ].join(',');
  var TEXT = [
    '.maison-eyebrow', 'h2', 'h3', '.maison-story__text', '.maison-editorial__cta', '.maison-split__cta',
    '.maison-carousel__cta', '.maison-story__cta', '.maison-editorial__more .button', '.maison-trust__item'
  ].join(',');

  function reveal(scope) {
    if (!animate || !scope) return;
    var first = firstSection();
    var groups = new Map();
    scope.querySelectorAll(ITEMS).forEach(function (el) {
      if (el.hasAttribute('data-maison-reveal') || el.closest('.mset') || skipReveal(el, first)) return;
      el.setAttribute('data-maison-reveal', el.matches('[data-maison-media]') ? 'media' : 'item');
      var parent = el.closest('li') ? el.closest('li').parentElement : el.parentElement;
      var i = groups.get(parent) || 0;
      el.style.setProperty('--maison-reveal-index', String(i % 4));
      groups.set(parent, i + 1);
      watch(el);
    });
    scope.querySelectorAll(GROUPS).forEach(function (group) {
      if (skipReveal(group, first)) return;
      var i = 0;
      var items = group.matches(TEXT) ? [group] : group.querySelectorAll(TEXT);
      items.forEach(function (el) {
        if (el.hasAttribute('data-maison-reveal') || el.closest('.maison-card, product-card')) return;
        el.setAttribute('data-maison-reveal', 'text');
        el.style.setProperty('--maison-reveal-index', String(i++ % 6));
        watch(el);
      });
    });
  }

  /* =========================================================
     3. CARRUSEL MAISON (sections/maison-carousel.liquid)
     ========================================================= */
  function updateArrows(viewport) {
    var track = viewport.querySelector('.maison-carousel__track');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var prev = viewport.querySelector('[data-dir="-1"]');
    var next = viewport.querySelector('[data-dir="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function initCarousels(scope) {
    scope.querySelectorAll('.maison-carousel__viewport:not([data-ready])').forEach(function (viewport) {
      viewport.setAttribute('data-ready', '');
      var track = viewport.querySelector('.maison-carousel__track');
      if (!track) return;
      track.addEventListener('scroll', function () { updateArrows(viewport); }, { passive: true });
      updateArrows(viewport);
    });
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.maison-carousel__arrow');
    if (!arrow) return;
    var viewport = arrow.closest('.maison-carousel__viewport');
    var track = viewport && viewport.querySelector('.maison-carousel__track');
    if (!track) return;
    var dir = parseInt(arrow.getAttribute('data-dir'), 10) || 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* =========================================================
     3b. VIDEOS DE FONDO (hero): Safari/iOS a veces no arranca solo
     ========================================================= */
  var mobileMQ = window.matchMedia('(max-width: 749px)');
  function playHeroVideos(scope) {
    (scope || document).querySelectorAll('[data-maison-hero] video').forEach(function (v) {
      // Solo se reproduce la versión visible (desktop o mobile); la otra no descarga
      var hidden = v.closest('.maison-hero__media--mobile') ? !mobileMQ.matches : (v.closest('.maison-hero__media--desktop') ? mobileMQ.matches : false);
      if (!v.dataset.maisonBound) {
        v.dataset.maisonBound = '1';
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });
        v.addEventListener('pause', function () { v.classList.remove('is-playing'); });
        v.addEventListener('timeupdate', function () { if (!v.paused) v.classList.add('is-playing'); });
      }
      if (!v.paused && v.readyState > 2) v.classList.add('is-playing');
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.controls = false;
      if (hidden) { v.pause(); v.preload = 'none'; return; }
      // Recién ahora se le pone la fuente al video visible (el HTML no la trae para no descargar los dos)
      if (v.hasAttribute('data-maison-lazy-video') && !v.dataset.maisonLoaded) {
        v.dataset.maisonLoaded = '1';
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
        v.load();
      }
      v.preload = 'auto';
      if (v.readyState < 2) {
        v.addEventListener('canplay', function () { if (v.paused) v.play().catch(function () {}); }, { once: true });
      }
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          // Ahorro de energía o autoplay bloqueado: queda el póster y se intenta al primer toque
          v.classList.add('is-blocked');
          var retry = function () { v.play().then(function () { v.classList.remove('is-blocked'); }).catch(function () {}); };
          ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (ev) { window.addEventListener(ev, retry, { once: true, passive: true }); });
        });
      }
    });
  }
  mobileMQ.addEventListener && mobileMQ.addEventListener('change', function () { playHeroVideos(document); });

  /* =========================================================
     4. FICHA DE PRODUCTO
     ========================================================= */
  // Garantía de despacho: cambia el título según la hora límite (blocks/maison-guarantees.liquid)
  function dispatchTexts(scope) {
    (scope || document).querySelectorAll('[data-mpa-dispatch]').forEach(function (el) {
      try {
        var hour = parseInt(el.getAttribute('data-hour'), 10) || 15;
        var wd = '', h = 0;
        new Intl.DateTimeFormat('en-US', {
          timeZone: el.getAttribute('data-tz') || 'America/Argentina/Buenos_Aires',
          weekday: 'short', hour: 'numeric', hourCycle: 'h23'
        }).formatToParts(new Date()).forEach(function (p) {
          if (p.type === 'weekday') wd = p.value;
          if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
        });
        var today = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(wd) > -1 && h < hour;
        var text = today ? el.getAttribute('data-today') : (el.getAttribute('data-next') || el.getAttribute('data-today'));
        if (text && el.textContent.trim() !== text) el.textContent = text;
      } catch (e) {}
    });
  }

  // Talle elegido en el selector de variantes
  function selectedSize(scope) {
    var value = '';
    (scope || document).querySelectorAll('variant-picker .variant-option').forEach(function (option) {
      var legend = option.querySelector('legend, label');
      if (!legend || !/talle|size|talla/i.test(legend.textContent)) return;
      var checked = option.querySelector('input:checked');
      var select = option.querySelector('select');
      if (checked) value = checked.value;
      else if (select) value = select.value;
    });
    return value;
  }

  // Producto de la página (snippets/maison-head.liquid → #maison-product)
  var productData = null;
  function PRODUCT() {
    if (!productData) {
      try { productData = JSON.parse(document.getElementById('maison-product').textContent) || {}; } catch (e) { productData = {}; }
    }
    return productData;
  }

  // Los enlaces a WhatsApp dentro de la ficha llevan el producto y el talle elegido
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (!a || a.hasAttribute('data-wa-keep')) return;
    var onProduct = document.querySelector('main[data-template*="product"]');
    var inDetails = a.closest('.product-details, maison-size-guide');
    if (!onProduct || !(inDetails || a.hasAttribute('data-wa-product') || a.hasAttribute('data-m-request'))) return;

    var product = PRODUCT();
    var title = a.getAttribute('data-m-title') || product.title || document.title;
    var url = a.getAttribute('data-m-url') || product.url || location.href;
    var size = selectedSize(document);
    var msg = a.hasAttribute('data-m-request')
      ? (T.req_msg || 'Hi! I would like to ask about') + ' ' + title + (size ? ' (' + (T.req_size || 'size') + ': ' + size + ')' : '') + ' - ' + url
      : (T.wa_product || 'Hola! Quiero consultar por') + ' ' + title + (size ? ' (' + (T.size_lower || 'talle') + ' ' + size + ')' : '') + ' ' + url;
    var num = (a.getAttribute('href').match(/wa\.me\/(\d+)/) || [])[1] || CFG.wa;
    if (!num) return;
    a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
    a.target = '_blank';
    a.rel = 'noopener';
  }, true);

  /* =========================================================
     5. COMPONENTES
     ========================================================= */
  // Precio estimado en pesos (blocks/maison-price-ars.liquid)
  var ratePromise = null;
  function getRate() {
    if (ratePromise) return ratePromise;
    try {
      var cached = JSON.parse(localStorage.getItem('maison-ars-rate') || 'null'); // se guarda 1 h entre visitas: no se vuelve a pedir en cada página
      if (cached && cached.u === CFG.arsRateUrl && Date.now() - cached.t < 3600000) return (ratePromise = Promise.resolve(cached.r));
    } catch (e) {}
    if (!CFG.arsRateUrl) return (ratePromise = Promise.resolve(null));
    ratePromise = fetch(CFG.arsRateUrl)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var r = parseFloat(d && (d.venta || d.sell || d.value));
        if (!r || isNaN(r)) return null;
        try { localStorage.setItem('maison-ars-rate', JSON.stringify({ r: r, t: Date.now(), u: CFG.arsRateUrl })); } catch (e) {}
        return r;
      })
      .catch(function () { return null; });
    return ratePromise;
  }
  function formatArs(amount) {
    var n = Math.round(amount);
    try { return '$' + n.toLocaleString('es-AR', { maximumFractionDigits: 0 }); } catch (e) { return '$' + n; }
  }

  if (!customElements.get('maison-ars-price')) {
    customElements.define('maison-ars-price', class extends HTMLElement {
      connectedCallback() {
        this.onVariant = this.onVariant.bind(this);
        document.addEventListener('variant:update', this.onVariant);
        this.render();
      }
      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
      }
      onVariant(event) {
        if (!this.dataset.blockId) return; // tarjetas y carrito: precio fijo
        var detail = event.detail || {};
        var data = detail.data || {};
        if (data.productId && String(data.productId) !== this.dataset.productId) return;
        var fresh = data.html && data.html.querySelector('maison-ars-price[data-block-id="' + this.dataset.blockId + '"]');
        if (fresh) this.dataset.price = fresh.dataset.price;
        else if (detail.resource && detail.resource.price != null) this.dataset.price = detail.resource.price;
        this.render();
      }
      render() {
        var cents = parseInt(this.dataset.price, 10);
        var value = this.querySelector('.maison-ars-price__value');
        if (!(cents > 0) || !value) { this.hidden = true; return; }
        getRate().then((rate) => {
          if (!rate) { this.hidden = true; return; }
          value.textContent = formatArs((cents / 100) * rate);
          this.hidden = false;
        });
      }
    });
  }

  // Guía de talles en panel lateral (blocks/maison-size-guide.liquid)
  if (!customElements.get('maison-size-guide')) {
    customElements.define('maison-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', (e) => {
          if (e.target.closest('.maison-size-guide__open')) { this.open(); return; }
          if (e.target.closest('[data-close]') || e.target === this.dialog) this.close();
        });
      }
      open() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        root.classList.add('maison-dialog-open');
      }
      close() {
        if (!this.dialog) return;
        this.dialog.close();
        root.classList.remove('maison-dialog-open');
      }
    });
  }

  // "Guía de talles" desde otros lugares de la ficha (fila Sizing & Fit de Detalles)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-maison-size-guide]');
    if (!t) return;
    var guide = document.querySelector('maison-size-guide');
    if (guide && guide.open) { e.preventDefault(); guide.open(); }
  });

  /* ---------- Tarjetas: carrusel de fotos ---------- */
  function mcardLoad(track) {
    if (track.dataset.loaded) return;
    track.dataset.loaded = '1';
    track.querySelectorAll('img[data-mcard-src]').forEach(function (img) {
      img.srcset = img.getAttribute('data-mcard-srcset') || '';
      img.src = img.getAttribute('data-mcard-src');
      img.removeAttribute('data-mcard-src');
    });
  }
  function mcardUpdate(track) {
    var media = track.closest('.maison-card__media');
    if (!media) return;
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    var n = track.children.length;
    media.querySelectorAll('.mcard-dots span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    var prev = media.querySelector('[data-mcard-prev]');
    var next = media.querySelector('[data-mcard-next]');
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i >= n - 1;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mcard-prev], [data-mcard-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var track = btn.closest('.maison-card__media').querySelector('[data-mcard-track]');
    if (!track) return;
    mcardLoad(track);
    var dir = btn.hasAttribute('data-mcard-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  }, true);
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mcard-track]')) return;
    mcardLoad(t);
    if (t._mcardRaf) return;
    t._mcardRaf = requestAnimationFrame(function () { t._mcardRaf = 0; mcardUpdate(t); });
  }, true);
  // Al salir de la tarjeta con el mouse, el carrusel vuelve suave a la primera foto
  document.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.matches || !e.target.matches('.maison-card')) return;
    var track = e.target.querySelector('[data-mcard-track]');
    if (track && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }, true);

  // En el celular: al tocar otra tarjeta, la anterior vuelve suave a la primera foto (como al sacar el mouse en PC)
  var mcardLast = null;
  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest && e.target.closest('.maison-card');
    var track = card && card.querySelector('[data-mcard-track]');
    if (mcardLast && mcardLast !== track && mcardLast.isConnected && mcardLast.scrollLeft > 0) {
      mcardLast.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (track) mcardLast = track;
  }, { capture: true, passive: true });

  // Las fotos siguientes se cargan al pasar el mouse o al tocar la tarjeta
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var card = e.target.closest && e.target.closest('.maison-card');
      var track = card && card.querySelector('[data-mcard-track]');
      if (track) mcardLoad(track);
    }, { capture: true, passive: true });
  });

  /* =========================================================
     ARRANQUE
     ========================================================= */
  window.Maison = window.Maison || {};
  window.Maison.reveal = reveal;

  // Ficha: mientras el botón de compra está en pantalla, el botón flotante de WhatsApp se oculta (no lo tapa)
  function watchBuyButton() {
    if (!('IntersectionObserver' in window)) return;
    var btn = document.querySelector('main [data-testid="standalone-add-to-cart"], main add-to-cart-component button[name="add"]');
    if (!btn) return;
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('maison-buy-visible', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(btn);
  }

  ready(function () {
    initBackToTop();
    watchBuyButton();
    onScroll();
    reveal(document.body);
    initCarousels(document);
    dispatchTexts(document);
    // El video del hero arranca cuando la página terminó de cargar: mientras tanto se ve la foto fija
    // y sus megas no compiten con lo que hace falta para mostrar la página
    var startVideos = function () { setTimeout(function () { playHeroVideos(document); }, 300); };
    if (document.readyState === 'complete') startVideos();
    else window.addEventListener('load', startVideos, { once: true });
  });

  // El tema vuelve a dibujar partes de la ficha al cambiar de variante
  document.addEventListener('variant:update', function () {
    requestAnimationFrame(function () { dispatchTexts(document); });
  });

  // Editor de temas
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    initCarousels(e.target);
    dispatchTexts(e.target);
    playHeroVideos(e.target);
  });
})();

/* =========================================================
   Carruseles con flechas (Novedades, Categorías, Editoriales, Marcas, Servicios)
   Las flechas van de tarjeta en tarjeta sin saltos:
   - el destino se calcula por tarjeta (no "desde donde esté"), así dos toques seguidos no quedan a mitad de camino;
   - mientras se anima se apaga el imán (scroll-snap), que en iPhone peleaba con la animación y hacía rebotar el carrusel;
   - nunca se pasa del principio ni del final.
   ========================================================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function posiciones(track, items) {
    var cs = getComputedStyle(track);
    var pad = parseFloat(cs.scrollPaddingLeft) || 0;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var base = track.getBoundingClientRect().left - track.scrollLeft;
    var out = [];
    items.forEach(function (it) {
      if (!it.offsetWidth) return; // ocultas (sin contenido)
      var p = Math.round(it.getBoundingClientRect().left - base - pad);
      p = Math.min(max, Math.max(0, p));
      if (!out.length || Math.abs(p - out[out.length - 1]) > 2) out.push(p);
    });
    if (!out.length || out[0] > 2) out.unshift(0);
    if (max - out[out.length - 1] > 2) out.push(max);
    return out;
  }

  window.maisonSlide = function (track, itemSelector, dir, cuantas) {
    if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll(itemSelector));
    var pos = posiciones(track, items);
    if (pos.length < 2) return;
    // Tarjeta actual: el destino pendiente si todavía se está moviendo, si no la más cercana
    var desde = track._maisonDestino != null ? track._maisonDestino : track.scrollLeft;
    var actual = 0, mejor = Infinity;
    pos.forEach(function (p, i) { var d = Math.abs(p - desde); if (d < mejor) { mejor = d; actual = i; } });
    var paso = Math.max(1, cuantas || 1);
    var destinoI = Math.min(pos.length - 1, Math.max(0, actual + dir * paso));
    var destino = pos[destinoI];
    if (Math.abs(destino - track.scrollLeft) < 2) return;

    track._maisonDestino = destino;
    track.style.scrollSnapType = 'none';
    clearTimeout(track._maisonFin);
    var terminar = function () {
      track.removeEventListener('scroll', alMover);
      track._maisonDestino = null;
      track.style.scrollSnapType = '';
    };
    var alMover = function () {
      clearTimeout(track._maisonFin);
      track._maisonFin = setTimeout(terminar, 140);
    };
    track.addEventListener('scroll', alMover, { passive: true });
    track._maisonFin = setTimeout(terminar, 900); // por si no llega ningún evento de scroll
    track.scrollTo({ left: destino, behavior: reduce ? 'auto' : 'smooth' });
  };
})();

/* Hero: toda la foto lleva al enlace del botón (sin un segundo enlace invisible encima) */
document.addEventListener('click', function (e) {
  var hero = e.target.closest && e.target.closest('[data-hero-href]');
  if (!hero || e.target.closest('a, button, input, select, textarea, video[controls]')) return;
  if (e.metaKey || e.ctrlKey) window.open(hero.getAttribute('data-hero-href'), '_blank');
  else window.location.href = hero.getAttribute('data-hero-href');
});

/* =========================================================
   Widget de Google (app Google & YouTube): su iframe llega sin título.
   Se le pone uno para lectores de pantalla apenas aparece y se deja de mirar.
   ========================================================= */
(function () {
  var TITLE = 'Calificaciones de la tienda en Google';
  function fix() {
    var f = document.getElementById('merchantwidgetiframe');
    if (f && !f.title) f.title = TITLE;
    return !!f;
  }
  if (fix() || !window.MutationObserver) return;
  // Solo se miran los hijos directos del body y del contenedor del widget (no todo el documento)
  var mo = new MutationObserver(function () {
    var wrap = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (wrap && !wrap.dataset.mwatch) {
      wrap.dataset.mwatch = '1';
      mo.observe(wrap, { childList: true });
    }
    if (fix()) mo.disconnect();
  });
  function start() { mo.observe(document.body, { childList: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
